import React, { useState, useEffect, useContext } from 'react';
import { Button, Modal, Form, Dimmer, Loader, FormInput, TextArea, Checkbox, Icon } from 'semantic-ui-react';
import './style.less';
import { toast } from 'react-toastify';

import { residentInvite, listResidentInvites, deleteResidentInvites } from '../../../services/messageRecipients';

const InviteAlexaUser = () => {
    const [loading, setLoading] = useState(false);
    const [refreshLoading, setRefreshLoading] = useState(true);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [inviteePayment, setInviteePayment] = useState<boolean>(false);

    const [invitations, setInvitations] = useState([]);

    const reload = async () => {
        setRefreshLoading(true);
        const invitations = await listResidentInvites();

        setInvitations(
            invitations.map((e) => ({
                _id: e._id,
                email: e.inviteEmail,
                name: `${e.alexaUser.firstName} ${e.alexaUser.lastName}`,
                sentAt: e.createdAt && new Date(e.createdAt).toLocaleDateString(),
            })),
        );
        setRefreshLoading(false);
    };

    useEffect(() => {
        reload();
    }, []);

    const submitInvite = async () => {
        const params = {
            alexaUser: {
                firstName,
                lastName,
            },
            inviteEmail: email,
            message: message ? message : `You have been invited to join Speak2 Family!`,
            invitedUserPays: inviteePayment,
        };
        console.log(params);
        setLoading(true);

        try {
            const response = await residentInvite(params);
            console.log('response:', response);
            setLoading(false);
            reload();
            setFirstName('');
            setLastName('');
            setEmail('');
            setMessage('');
            setInviteePayment(false);

            toast.success('Invite sent successfully', {
                position: 'bottom-center',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
            });
        } catch (err) {
            console.log('err:', err);

            setLoading(false);
            toast.warn('Something went wrong, try again', {
                position: 'bottom-center',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
            });
        }
    };

    const handleDelete = async (invitationId) => {
        setDeleteLoading(true);

        try {
            const response = await deleteResidentInvites(invitationId);
            setDeleteLoading(false);
            reload();
            toast.success('Deleted successfully', {
                position: 'bottom-center',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
            });
        } catch (err) {
            setDeleteLoading(false);
            toast.warn('Something went wrong, try again', {
                position: 'bottom-center',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
            });
        }
    };

    return (
        <div className="relative-list invite-alexa-user">
            <div className="invite-resident">
                <h4 className="title">Invite Alexa User</h4>
                <Form loading={loading}>
                    <div className="name-section">
                        <FormInput
                            value={firstName}
                            onChange={(e) => {
                                setFirstName(e.target.value);
                            }}
                            required
                            name="FirstName"
                            placeholder="First Name"
                        ></FormInput>
                        <FormInput
                            value={lastName}
                            onChange={(e) => {
                                setLastName(e.target.value);
                            }}
                            required
                            name="LastName"
                            placeholder="Last Name"
                        ></FormInput>
                    </div>
                    <FormInput
                        value={email}
                        onChange={(e) => {
                            setEmail(e.target.value);
                        }}
                        required
                        name="email"
                        placeholder="Email"
                        type="email"
                    ></FormInput>
                    <TextArea
                        value={message}
                        onChange={(e) => {
                            console.log(e.currentTarget.value);
                            setMessage(e.currentTarget.value);
                        }}
                        name="message"
                        placeholder="Message(optional). Default - You have been invited to join Speak2 Family!"
                        type="textarea"
                        rows="1"
                    ></TextArea>
                    <Checkbox
                        checked={inviteePayment}
                        onChange={(e, { checked }) => {
                            setInviteePayment(checked ? true : false);
                        }}
                        label="Invitee will pay"
                    />
                    <br />
                    <Button
                        disabled={!firstName || !lastName || !email}
                        primary
                        size="small"
                        className="invite-button"
                        onClick={() => submitInvite()}
                    >
                        Invite Alexa User
                    </Button>
                </Form>
            </div>
            <div className="alexa-user-invites">
                <Dimmer className="pt-80" active={refreshLoading} inverted>
                    <Loader active={refreshLoading} />
                </Dimmer>
                <div className="invited-title">Invited</div>
                {invitations.map((invite) => {
                    const { name, email, sentAt, _id } = invite;
                    return (
                        <div className="invite">
                            <div className="details">
                                <div className="name">{name}</div>
                                <div>
                                    {email} <span className="timestamp">{sentAt ? sentAt : ''}</span>
                                </div>
                            </div>
                            <div className="action">
                                {/* <Button size="mini" basic>
                                    <Icon name="send"></Icon>
                                    Resend Invite
                                </Button> */}
                                <Button
                                    size="mini"
                                    color="red"
                                    basic
                                    onClick={() => handleDelete(_id)}
                                    loading={deleteLoading}
                                >
                                    <Icon name="trash" />
                                    Delete
                                </Button>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default InviteAlexaUser;
